<template>
  <div class="order">
    <div class="head">
      <AppFrame/>
    </div>
    <div class="cont">
      <div class="van-cont-block">
        <van-form ref="submitForm">
          <van-field
            name="money"
            v-model="subForm.money"
            type="number"
            label="申请金额"
            placeholder="请输入金额"
          ></van-field>
          <van-field
            name="desc"
            v-model="subForm.desc"
            rows="3"
            maxlength="100"
            show-word-limit
            placeholder="请输入申请理由"
            type="textarea"
          ></van-field>
          <div style="margin: 16px;">
            <van-button block type="info" @click="onSubmit">
              提交
            </van-button>
          </div>
          <div style="height: 40px"></div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import AppFrame from '@/components/AppFrame'
export default {
  name: "AddInvoice",
  components: {
    AppFrame
  },
  data() {
    return {
      subForm: {
        money: null,
        desc: ''
      }
    }
  },
  created() {
  },
  mounted() {
   
  },
  methods: {
    onSubmit(values) {
      console.log('subForm', this.subForm);
      this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      let data = {
        ...this.subForm
      }
      data.money = parseFloat(data.money)
      // console.log(data)
      if(data.money == ''){
        this.$toast("请输入金额");
        return false;
      }
      if(data.desc == ''){
        this.$toast("请输入申请理由");
        return false;
      }
      this.$api.apis.accountCreditInfoApply(data).then(res => {
        console.log(res)
        this.$toast.clear()
        if(res.flag=='200'){
          this.$toast.success('提交成功');
          this.$dialog.alert({
            message: '申请提交成功！',
            confirmButtonText:'确定'
          }).then(() => {
            this.$router.push({path:'/Credit'})
          });
        }else{
          this.$toast(res.msg);
        }
      });
    },
  },
  destroyed() {
  },
  filters: {}
};
</script>
<style scoped lang="less">
  @import '../../styles/order.less';
  .order .head{
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Credit/Apply.vue